"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTabsDefaultProps = exports.createTabsTheme = void 0;
exports.createTabsTheme = function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            minHeight: 36.5,
        },
        indicator: {
            display: "flex",
            justifyContent: "center",
            backgroundColor: "transparent",
            "& > div": {
                backgroundColor: palette.primary.main,
                borderRadius: 1,
                width: 30,
                height: 2,
            },
        },
    });
};
exports.createTabsDefaultProps = function () { return ({}); };
